import React, { FC } from 'react'
import { HStack, Typography, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import Notification = App.Models.Notification

const VisaManagerChangedNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification, portal = 'Agency' }) => {
  return (
    <HStack
      spacing="3px"
      style={{
        flexWrap: 'wrap',
        cursor: 'pointer',
        padding: '12px',
      }}
      onClick={() => {
        if (portal === 'Agency') {
          router.visit(`/visas/${notification.data.visa_id}`)
        } else {
          if (portal === 'B2B') {
            router.visit(`/b2b/leads/${notification.data.lead_id}`)
          }
        }
      }}
    >
      {portal === 'Agency' && <Typography variant="body-small-bold">{notification.data.event_by}</Typography>}
      {portal === 'B2B' && (
        <>
          <Typography variant="body-small" color={XelaColor.Gray6}>
            Agent
          </Typography>
          <Typography variant="body-small" color={XelaColor.Pink3}>
            {notification.data.event_by}
          </Typography>
        </>
      )}
      <Typography variant="body-small" color={XelaColor.Gray6}>
        changed {notification.data.title} from
      </Typography>
      <Typography variant="body-small-bold" color={XelaColor.Gray3}>
        {notification.data.old}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        to
      </Typography>
      <Typography variant="body-small-bold" color={XelaColor.Gray3}>
        {notification.data.new}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        for Client
      </Typography>
      <Typography variant="body-small-bold" color={XelaColor.Orange3}>
        #{notification.data.lead_name}
      </Typography>
    </HStack>
  )
}

export default VisaManagerChangedNotification
